import React from 'react';
import { GenericError } from 'wix-rich-content-ui-components';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return /* @__PURE__ */ React.createElement(GenericError, { text: this.props.t("Plugin_Rendering_Error"), dataHook: "rendering-error" });
    }
    return this.props.children;
  }
}

export { ErrorBoundary };
//# sourceMappingURL=ErrorBoundary.js.map
